import { tokens } from '@equinor/eds-tokens';
import { button } from './button.js';
import mergeDeepRight from '../../../node_modules/.pnpm/ramda@0.29.0/node_modules/ramda/es/mergeDeepRight.js';

var _tokens$colors = tokens.colors,
  primaryWhite = _tokens$colors.text.static_icons__primary_white.rgba,
  _tokens$colors$intera = _tokens$colors.interactive,
  primaryColor = _tokens$colors$intera.primary__resting.rgba,
  primaryHoverColor = _tokens$colors$intera.primary__hover.rgba,
  secondaryColor = _tokens$colors$intera.secondary__resting.rgba,
  secondaryHoverColor = _tokens$colors$intera.secondary__link_hover.rgba,
  dangerColor = _tokens$colors$intera.danger__resting.rgba,
  dangerHoverColor = _tokens$colors$intera.danger__hover.rgba,
  buttonBorderRadius = tokens.shape.button.borderRadius;
var primary = mergeDeepRight(button, {
  background: primaryColor,
  typography: {
    color: primaryWhite
  },
  border: {
    type: 'border',
    style: 'solid',
    width: '1px',
    color: primaryColor,
    radius: "var(--eds_button__radius, ".concat(buttonBorderRadius, ")")
  },
  states: {
    hover: {
      background: primaryHoverColor
    }
  }
});
var secondary = mergeDeepRight(primary, {
  background: secondaryColor,
  border: {
    color: secondaryColor
  },
  states: {
    hover: {
      background: secondaryHoverColor,
      border: {
        color: secondaryHoverColor
      }
    }
  }
});
var danger = mergeDeepRight(primary, {
  background: dangerColor,
  border: {
    color: dangerColor
  },
  states: {
    hover: {
      background: dangerHoverColor,
      border: {
        color: dangerHoverColor
      }
    }
  }
});

export { danger, primary, secondary };
